import { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ClickAwayListener } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { InfoOutlined } from '@mui/icons-material';
import decodeHtmlEntities from '@/utils/decodeHtmlEntities';
import { capitalizeFirstLetter } from '@/utils/strings';

const subtypeHeaderFontSize: any = {
    h1: 24,
    h2: 23,
    h3: 22,
    h4: 21,
    h5: 20,
    h6: 19,
};

interface Props {
    children?: any;
    header?: string;
    label?: string;
    required?: boolean;
    description?: string;
    subtype?: string;
}

const ContainerComponent = ({ children, header, label, required, description, subtype }: Props) => {
    const [tooltipState, setTooltipState] = useState(false);

    const handleTooltipClose = () => {
        setTooltipState(false);
    };

    const handleTooltipOpen = () => {
        setTooltipState(true);
    };

    return (
        <Box
            sx={{
                backgroundColor: 'white',
                borderRadius: 5,
            }}
        >
            {header && (
                <Box
                    sx={{
                        padding: '10px 15px',
                        borderRadius: 5,
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: subtype ? subtypeHeaderFontSize[subtype] : 24,
                            fontWeight: 500,
                        }}
                    >
                        {decodeHtmlEntities(capitalizeFirstLetter(header))}
                    </Typography>
                </Box>
            )}
            {children && (
                <Box
                    sx={{
                        padding: 10,
                        display: 'grid',
                        justifyContent: 'start',
                    }}
                >
                    {label && (
                        <Box>
                            <Typography
                                sx={{
                                    fontSize: 16,
                                    marginBottom: 15,
                                    fontFamily: "'Google Sans',Roboto,Arial,sans-serif",
                                }}
                            >
                                {capitalizeFirstLetter(label)} {required ? '*' : ''}{' '}
                                {description && (
                                    <ClickAwayListener onClickAway={handleTooltipClose}>
                                        <Tooltip
                                            title={decodeHtmlEntities(capitalizeFirstLetter(description))}
                                            placement='top'
                                            arrow
                                            PopperProps={{
                                                disablePortal: true,
                                            }}
                                            onClose={handleTooltipClose}
                                            open={tooltipState}
                                            disableFocusListener
                                            disableHoverListener
                                            disableTouchListener
                                            componentsProps={{
                                                tooltip: {
                                                    sx: { fontSize: 16 },
                                                },
                                            }}
                                        >
                                            <InfoOutlined
                                                sx={{
                                                    fontSize: 20,
                                                    opacity: 0.7,
                                                    marginBottom: -4,
                                                }}
                                                onClick={handleTooltipOpen}
                                            />
                                        </Tooltip>
                                    </ClickAwayListener>
                                )}
                            </Typography>
                        </Box>
                    )}
                    <Box>{children}</Box>
                </Box>
            )}
        </Box>
    );
};

export default ContainerComponent;
